require('./src/styles/global.css')
require('@fontsource/quicksand')
require('./node_modules/sal.js/dist/sal.css')
require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')